// ----------------------------------------------------------------------
// <copyright file="Izenda.CodeMirror.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * CodeMirror component
 */
!(function () {
  var React = require('react');
  var CodeMirrorExt = require('./Izenda.CodeMirrorExt');

  var CodeMirror = React.createClass({

    propTypes: {
      value: React.PropTypes.string,
      defaultValue: React.PropTypes.string,
      className: React.PropTypes.string,
      onChange: React.PropTypes.func,
      options: React.PropTypes.object,
      reportPartContent: React.PropTypes.object
    },

    getCodeMirror: function() {
      return this.codeMirror;
    },

    componentDidMount: function() {
      var textareaNode = this.refs.textarea;

      this.codeMirror = CodeMirrorExt.fromTextArea(textareaNode, this.props.options);
      this.codeMirror.on('change', this.handleChange);
      this.codeMirror.setValue(this.props.defaultValue || this.props.value || '');

      !!this.props.reportPartContent.isFormatted 
        && this.codeMirror.autoFormatAll();
    },

    handleChange: function(doc, change) {
      if (this.props.onChange && change.origin != 'setValue') {
        this.props.onChange(doc.getValue());
      }
    },

    componentWillUnmount: function() {
      if (this.codeMirror) {
        this.codeMirror.toTextArea();
      }
    },

    searchCode: function(text) {
      return this.codeMirror.searchCode(text);
    },

    replaceCode: function(text, replace) {
      return this.codeMirror.replaceCode(text, replace);
    },

    insertContent: function(text) {
      this.codeMirror.replaceSelection(text);
      this.codeMirror.setCursor(this.codeMirror.getCursor());
    },

    execCommand: function(cmd) {
      switch (cmd) {
        case 'Undo':
          this.codeMirror.execCommand('undo');
          break;
        case 'Redo':
          this.codeMirror.execCommand('redo');
          break;
        case 'Reformat':
          this.props.reportPartContent.markFormated();
          this.codeMirror.autoFormatAll();
          break;
      }
    },

    componentWillReceiveProps: function(nextProps) {
      if (this.codeMirror && nextProps.value !== undefined
        && this.codeMirror.getValue() != nextProps.value) {

        this.codeMirror.setValue(nextProps.value);
      }

      if(this.codeMirror && nextProps.options !== this.props.options) {
        this.codeMirror.setOption('lineWrapping', nextProps.options.lineWrapping);
      }
    },

    render: function () {
      return (
        <div className='izenda-CodeMirror'>
          <textarea
            ref="textarea"
            name={this.props.path}
            defaultValue={this.props.value}
            onChange={this.valueChanged}
            autoComplete="off" />
        </div>
      );
    }
  });

  module.exports = CodeMirror;
}());



// WEBPACK FOOTER //
// ./ui/share/components/controls/CodeMirror/Izenda.CodeMirror.jsx